



































































































































































import {Component, Vue} from "vue-property-decorator";
import {StateMachine} from "frontend-core";
import {Agent} from "@/models/Agent";
import SearchSegmentation from "@/views/SearchSegmentation.vue";
import {UserRoleEnum} from "@/models/UserRoleEnum";
import {AgentToAdd} from "@/models/AgentToAdd";
import {AgentToAddDto} from "@/models/AgentToAddDto";
import {IAgentService} from "@/services/IAgentService";
import {container} from "@/services/registerServiceProvider";

type AllowedToAddAgentRole = {
  title: string;
  roleName: UserRoleEnum
}

@Component({
  components: {SearchSegmentation},
})
export default class AddAgentModal extends Vue {
  public dialog: boolean = false;
  public rolesArray: AllowedToAddAgentRole[] = [
    {title: "Агент", roleName: UserRoleEnum.agent},
    {title: "Субагент", roleName: UserRoleEnum.subAgent},
    {title: "Куратор", roleName: UserRoleEnum.curator},
    {title: "Субкуратор(Помощник)", roleName: UserRoleEnum.subCurator},
    {title: "Наставник", roleName: UserRoleEnum.mentor},
    {title: "Тех. поддержка", roleName: UserRoleEnum.techSupport},
  ];
  public agentToAdd: AgentToAdd = new AgentToAdd();
  public selectedAgent: Agent | null = null;
  public readonly stateMachine: StateMachine = new StateMachine("idle", {
    idle: ["loading", "error"],
    loading: ["success", "error", "idle"],
    success: ["idle"],
    error: ["idle"],
  });
  public newAgent: {id: string, name: string} | null = null;
  public errorText: string = "";
  private readonly agentService: IAgentService = container.resolve("IAgentService");

  get hintForEmailPhone(): string | undefined {
    return this.agentToAdd.role === UserRoleEnum.mentor || this.agentToAdd.role === UserRoleEnum.curator || this.agentToAdd.role === UserRoleEnum.subCurator
      ? "Обязательно для заполнения"
      : undefined;
  }

  async addAgent() {
    this.stateMachine.transition("loading");
    this.errorText = "";
    const dto: AgentToAddDto = new AgentToAddDto(this.agentToAdd);

    if (dto.validate()) {
      await this.agentService.addNewAgent(dto.serialize())
        .then((res) => {
          this.stateMachine.transition("success");
          this.newAgent = {id: res, name: this.agentToAdd.name};
          this.agentToAdd = new AgentToAdd();
          this.selectedAgent = null;
        })
      .catch((error) => {
        this.errorText = error.response?.data.detail || "";
        this.stateMachine.transition("error");
      })
    } else {
      this.stateMachine.transition("idle");
    }
  }

  selectParent(agent: Agent) {
    this.selectedAgent = agent;
    this.agentToAdd.parentAgentId = agent.id;
    this.agentToAdd.errors.parentAgentId = [];
  }

  clearForm() {
    this.newAgent = null;
    this.agentToAdd = new AgentToAdd();
    this.selectedAgent = null;
    this.errorText = "";
    this.stateMachine.transition("idle");
  }

  toIdle(e: boolean): void {
    if (!e) {
      this.stateMachine.transition("idle");
    }
  }
}
